import { render } from "./SceneUI.vue?vue&type=template&id=38e4eddc&scoped=true"
import script from "./SceneUI.vue?vue&type=script&lang=ts"
export * from "./SceneUI.vue?vue&type=script&lang=ts"

import "./SceneUI.vue?vue&type=style&index=0&id=38e4eddc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-38e4eddc"

export default script